import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "q-chip__text" }
const _hoisted_2 = {
  key: 0,
  class: "marked-item_min"
}
const _hoisted_3 = { class: "marked-item__min-text" }
const _hoisted_4 = { class: "marked-item__min-value q-ps-1" }
const _hoisted_5 = {
  key: 1,
  class: "marked-item_max"
}
const _hoisted_6 = { class: "marked-item__max-text" }
const _hoisted_7 = { class: "marked-item__max-value q-ps-1" }

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {inject, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {formatPrice} from "@/core/utils";



import {SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'MarkedFilterRangeButton',
  props: ['activeFilter', 'filterName'],
  setup(__props) {

const filtersStore = useFiltersStore();
const serpStore = useSerpResultsStore()

const props = __props

const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const {getCurrencyCode} = storeToRefs(serpStore)
onMounted(() => {
    filtersStore.registerAsActiveFilter(props.filterName, props.activeFilter)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "serp__filters--marked-item-button q-btn q-btn-light q-btn-sm q-me-2 q-mb-2 q-position-relative q-rounded-3 q-shadow-sm",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(filtersStore).removeRangeFilter(__props.filterName)), ["stop","prevent"]))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(filtersStore).getFilterLabelByFilterName(__props.filterName)) + ": ", 1),
      (__props.activeFilter.min)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(SmartSearchTranslations).filters.from), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.filterName === 'price' ? _unref(formatPrice)(__props.activeFilter.min, _unref(getCurrencyCode), true) :
            `${__props.activeFilter.min} ${_unref(filtersStore).getFilterUnit(__props.filterName) || ''}`), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.activeFilter.max)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, " " + _toDisplayString(_unref(SmartSearchTranslations).filters.to), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.filterName === 'price' ? _unref(formatPrice)(__props.activeFilter.max, _unref(getCurrencyCode), true) :
            `${__props.activeFilter.max} ${_unref(filtersStore).getFilterUnit(__props.filterName) || ''}`), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "q-chip__close",
      "aria-hidden": "true"
    }, [
      _createElementVNode("svg", {
        class: "q-chip__icon",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          d: "M6 6l12 12M18 6L6 18",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round"
        })
      ])
    ], -1))
  ]))
}
}

})